// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscribe-button-subscribe-button-6ccd2 .ant-btn{margin-top:0!important}.subscribe-button-subscribe-button-6ccd2 .ant-btn{color:var(--GRAY_11);font-family:PingFangSC-Medium;font-size:16px;font-weight:500;height:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscribe-button": "subscribe-button-subscribe-button-6ccd2",
	"subscribeButton": "subscribe-button-subscribe-button-6ccd2"
};
export default ___CSS_LOADER_EXPORT___;
